export default __webpack_public_path__ + "img/a2963ffe8116e613e608f15ec34a3bee.svg";